<template>
    <div class="row">

        <form class="w-100">

            <div class="col-md-12">
                <div class="card card-bordered">
                    <div class="card-inner">

                        <div class="row">
                            <div class="col">

                                <div class="form-group">
                                    <label class="form-label" for="tour_select">{{ translations.tour_number }}</label>
                                    <div class="form-control-wrap">
                                        <div class="form-control-select">
                                            <select class="form-control" id="tour_select" v-on:change="fetchCompetitorData($event)">
                                                <option v-for="tour in event.tours" :key="tour.id" :value="tour.id">{{ tour.order }} ({{ tour.difficulty.title }})</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col">

                                <div class="form-group">
                                    <label class="form-label" for="team_select">{{ translations.team_number }}</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control" id="team_select" v-on:input="fetchCompetitorData($event)" v-on:keyup.enter="focusNextInput($event.target)">
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-md-12 py-3">
                <div class="card card-bordered">
                    <div class="card-inner">

                        <div class="row">

                            <div class="col-md-6">

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.start_tc_provided }}</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.given_tc_start_in" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label">{{ translations.start_tc_in }}</label>
                                            <span class="form-note">Points for start TC in: <span v-text="calculatedPointsForStartTcIn"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.tc_start_in" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label">{{ translations.start_tc_out }}</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.tc_start_out" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.start_tc_round_in }}</label>
                                            <span class="form-note">Points for TC start round in: <span v-text="calculatedPointsForStartRoundIn"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.tc_round_start_in" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.start_tc_round_out }}</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.tc_round_start_out" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.stop_tc_round }}</label>
                                            <span class="form-note">Points for TC stop round: <span v-text="calculatedPointsForStopRound"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="result.tc_round_stop" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.missed_controls }}</label>
                                            <span class="form-note">Points for missed controls: <span v-text="calculatedPointsForMissedControls"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="number" class="form-control" placeholder="0" v-model="result.missed_controls" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3 align-center">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.distance_driven }}</label>
                                            <span class="form-note">Points for distance of round: <span v-text="calculatedPointsForDistance"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="number" step="1" class="form-control" placeholder="0" v-model="result.distance_driven" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="col-md-6">
                                <!-- gtc inputs -->

                                <div class="row g-3 align-center" v-for="(time_control, index) in time_controls" :key="time_control.index">
                                    <div class="col-lg-5">
                                        <div class="form-group">
                                            <label class="form-label mt-4">{{ translations.time_at_gtc }} {{ (index + 1) }}</label>
                                            <span class="form-note">Points at GTC {{ (index + 1) }}: <span v-text="time_control.points"></span></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="form-group">
                                            <label class="form-label"></label>
                                            <div class="form-control-wrap">
                                                <input type="time" class="form-control" placeholder="00:00" v-model="time_control.time_at_control" v-on:change="triggerUpdate" v-on:keyup.enter="focusNextInput($event.target)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </form>
    </div>

</template>

<style scoped>

</style>

<script>

const moment = require('moment')

export default {
    name: 'organisationDotresultInputForm',

    props: [
        'organisation',
        'event',
        'user',
        'translations',
    ],

    data() {
        return {
            result: {},
            time_controls: [],
            tour_data: {},
            timeout: null,
            waitTime: 5000, // 5 seconds

            calculatedPointsForStartTcIn: 0,
            calculatedPointsForStartRoundIn: 0,
            calculatedPointsForStopRound: 0,
            calculatedPointsForMissedControls: 0,
            calculatedPointsForDistance: 0,
        }
    },

    methods: {
        fetchCompetitorData(event) {

            let teamNumber = $('input#team_select').val(),
                tourNumber = $('select#tour_select').val(),
                app = this

            if (teamNumber.length > 2) {
                // Only when the team number is a "valid" number, do the API call to fetch the data.

                axios.get('/api/internal/dotresult/fetch-team-data', {
                    params: {
                        event_id: app.event.id,
                        team_number: teamNumber,
                        tour_number: tourNumber
                    }
                }).then((response) => {

                    this.assignVueData(response);

                }).catch((errors) => {
                    this.result = {}; // reset object
                    this.time_controls = []; // reset object
                    this.tour_data = {}; // reset object
                    NioApp.Toast('Team not found', 'error', { position: 'top-right', timeOut: 5000 })
                    console.log(errors)
                })
            }

        },

        triggerUpdate() {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(this.updateResultData.bind(this), this.waitTime);
        },

        assignVueData(response) {
            this.result = Object.assign({}, this.result, {
                given_tc_start_in: response.data.results.given_tc_start_in ? moment(response.data.results.given_tc_start_in).format('HH:mm') ?? null : null,
                tc_start_in: response.data.results.tc_start_in ? moment(response.data.results.tc_start_in).format('HH:mm') ?? null : null,
                tc_start_out: response.data.results.tc_start_out ? moment(response.data.results.tc_start_out).format('HH:mm') ?? null : null,
                tc_round_start_in: response.data.results.tc_round_start_in ? moment(response.data.results.tc_round_start_in).format('HH:mm') ?? null : null,
                tc_round_start_out: response.data.results.tc_round_start_out ? moment(response.data.results.tc_round_start_out).format('HH:mm') ?? null : null,
                tc_round_stop: response.data.results.tc_round_stop ? moment(response.data.results.tc_round_stop).format('HH:mm') ?? null : null,

                raw_given_tc_start_in: response.data.results.given_tc_start_in ? moment(response.data.results.given_tc_start_in) ?? null : null,
                raw_tc_start_in: response.data.results.tc_start_in ? moment(response.data.results.tc_start_in) ?? null : null,
                raw_tc_start_out: response.data.results.tc_start_out ? moment(response.data.results.tc_start_out) ?? null : null,
                raw_tc_round_start_in: response.data.results.tc_round_start_in ? moment(response.data.results.tc_round_start_in) ?? null : null,
                raw_tc_round_start_out: response.data.results.tc_round_start_out ? moment(response.data.results.tc_round_start_out) ?? null : null,
                raw_tc_round_stop: response.data.results.tc_round_stop ? moment(response.data.results.tc_round_stop) ?? null : null,

                missed_controls: response.data.results.missed_controls ?? 0,
                distance_driven: response.data.results.distance_driven ?? 0,
            })

            this.tour_data = response.data.tour_data;

            // Build the GTC inputs here
            this.time_controls = []; // reset the time controls
            response.data.time_controls.forEach((timeControlObject, index) => {
                this.$set(this.time_controls, index, timeControlObject)
            });

            // get the input data for the time controls and then fill them
            response.data.time_control_results.forEach((resultObject) => {
                this.$set(this.time_controls[this.time_controls.findIndex(x => x.id === resultObject.event_time_control_id)], 'time_at_control', resultObject.time_at_control ? moment(resultObject.time_at_control).format('HH:mm') ?? null : null)

                // points calculator
                let timeControl = this.time_controls[this.time_controls.findIndex(x => x.id === resultObject.event_time_control_id)];
                let minutesToAdd = Math.floor((timeControl.distance / 1000) * 60) / this.tour_data.average_speed;
                let idealTimeAtGtc = moment(this.result.raw_tc_round_start_out).add(minutesToAdd, 'minutes');
                this.$set(timeControl, 'points', this.calculateTimePoints(idealTimeAtGtc, resultObject.time_at_control));
            });

            this.calculateAllPointsInView();
        },

        updateResultData() {

            let teamNumber = $('input#team_select').val(),
                tourNumber = $('select#tour_select').val()

            axios.put('/api/internal/dotresult/update-result-data', {
                results: this.result,
                event_id: this.event.id,
                team_number: teamNumber,
                tour_number: tourNumber,
                time_control_results: this.time_controls
            }).then((response) => {
                //console.log(response.data)

                // assign the data to the vue models
                this.assignVueData(response);

            }).catch((errors) => {
                this.result = {}; // reset object
                this.time_controls = []; // reset object
                this.tour_data = {}; // reset object
                //console.log(errors)
            });

        },

        calculateAllPointsInView() {
            this.calculatedPointsForStartTcIn = this.calculateTimePoints(this.result.raw_given_tc_start_in, this.result.raw_tc_start_in);

            let idealTimeAtStart = moment(this.result.raw_tc_start_out).add(this.tour_data.time_connection_start_round, 'minutes');
            this.calculatedPointsForStartRoundIn = this.calculateTimePoints(idealTimeAtStart, this.result.raw_tc_round_start_in);

            let minutesToAdd = Math.floor((this.tour_data.total_distance / 1000) * 60) / this.tour_data.average_speed;
            let idealTimeAtStop = moment(this.result.raw_tc_round_start_out).add(minutesToAdd, 'minutes');
            this.calculatedPointsForStopRound = this.calculateTimePoints(idealTimeAtStop, this.result.raw_tc_round_stop);

            this.calculatedPointsForMissedControls = this.result.missed_controls * 20; // TODO: make dynamic per event

            let resultingDistance = (this.result.distance_driven ?? 0) - (this.tour_data.total_distance ?? 0);
            let pointsForDistance = 0;
            if (resultingDistance < 0) {
                pointsForDistance = (Math.floor(Math.abs(resultingDistance) / 100) * 2);
            } else {
                pointsForDistance = Math.floor(Math.abs(resultingDistance) / 100);
            }
            this.calculatedPointsForDistance = Math.abs(pointsForDistance);
        },

        /**
         * Intern function to calculate the points for given time
         * @param idealTime
         * @param resultTime
         * @returns {number}
         */
        calculateTimePoints(idealTime, resultTime) {

            if (!idealTime || !resultTime) {
                return 0;
            }

            let idealTimeObject = moment(idealTime),
                resultTimeObject = moment(resultTime),
                points = 0;

            let difference = resultTimeObject.diff(idealTimeObject, 'minutes');

            // console.log(difference)

            if (difference < 0) {
                points = Math.abs(difference) * 2;
            } else {
                points = difference;
            }
            return parseInt(Math.abs(points));
        },

        focusNextInput(elem) {
            const currentIndex = Array.from(elem.form.elements).indexOf(elem);
            elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).focus();
        }
    },
}

</script>
